<div class="onboarding-card-title" [translate]="titleKey"></div>
<p class="onboarding-card-subtitle" [translate]="subtitleKey"
    [translateParams]="{ language: languageName }">
</p>

@if (showJobSection && jobForm) {
<!-- Section 1 : Métier + Secteur -->
<div class="section">
    <div class="section-title" translate>ai-exam-onboarding.professional-universe.section.activity</div>
    <lib-job-form-fuse-no-user [jobForm]="jobForm" appearance="onboarding"></lib-job-form-fuse-no-user>
</div>

<div class="section-divider"></div>
}

<!-- Section 2 : Interlocuteurs -->
<div class="section">
    <div class="section-title">
        <span translate [translateParams]="{ language: languageName }">ai-exam-onboarding.professional-universe.section.interlocutors</span>
    </div>
    <div class="chips">
        @for (option of interlocutorOptions; track option.value) {
        <button
            type="button"
            class="chip"
            [class.selected]="isInterlocutorSelected(option.value)"
            (click)="toggleInterlocutor(option.value)">
            <span translate>{{ option.labelKey }}</span>
        </button>
        }
    </div>
</div>

<div class="section-divider"></div>

<!-- Section 3 : Taille organisation + Management -->
<div class="fields-grid fields-grid--bottom">
    <div>
        <div class="section-title" translate>ai-exam-onboarding.professional-universe.section.company-size</div>
        <div class="size-group">
            @for (option of companySizeOptions; track option.value) {
            <button
                type="button"
                class="size-btn"
                [class.selected]="answers.company_size === option.value"
                (click)="selectCompanySize(option.value)">
                <span class="size-icon">{{ option.icon }}</span>
                <span class="size-label" translate>{{ option.labelKey }}</span>
                <span class="size-sub" translate>{{ option.subLabelKey }}</span>
            </button>
            }
        </div>
    </div>

    <div>
        <div class="section-title" translate>ai-exam-onboarding.professional-universe.section.is-manager</div>
        <div class="toggle-group">
            <button
                type="button"
                class="toggle-btn"
                [class.selected]="answers.is_manager === true"
                (click)="selectIsManager(true)">
                <span translate>ai-exam-onboarding.personalization.yes</span>
            </button>
            <button
                type="button"
                class="toggle-btn"
                [class.selected]="answers.is_manager === false"
                (click)="selectIsManager(false)">
                <span translate>ai-exam-onboarding.personalization.no</span>
            </button>
        </div>
        @if (answers.is_manager === true) {
        <div class="conditional visible">
            <div class="field-label field-label--compact" translate>
                ai-exam-onboarding.professional-universe.section.team-size
            </div>
            <div class="chips">
                @for (option of teamSizeOptions; track option.value) {
                <button
                    type="button"
                    class="chip"
                    [class.selected]="answers.team_size === option.value"
                    (click)="selectTeamSize(option.value)">
                    <span translate>{{ option.labelKey }}</span>
                </button>
                }
            </div>
        </div>
        }
    </div>
</div>

<div class="onboarding-actions">
    @if (showBackButton) {
    <button type="button" class="onboarding-btn-back" (click)="back.emit()">
        ← <span translate>ai-exam-onboarding.back</span>
    </button>
    }
    <button
        type="button"
        class="onboarding-btn-primary flex-1"
        [disabled]="!canContinue()"
        (click)="continue.emit()">
        <span translate>ai-exam-onboarding.continue</span>
    </button>
</div>
